import { useQuery } from "@tanstack/react-query";
import { communityApi } from "@bw/shared/api";
import type { PostResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A single post (GET /communities/posts/{id}), returned VERBATIM — author by
 * display_name, content, the server's score / comment_count. No derived state.
 *
 * Disabled until an id is present so an unresolved route param never fires a
 * bogus request. Cached under the `social.post(id)` slot. Read-only (Slice 2);
 * a load failure (404 / reject) surfaces on `query.isError` for the page to show
 * an honest error with a back-link.
 */
export function usePost(postId: string | undefined) {
  return useQuery<PostResponse>({
    queryKey: queryKeys.social.post(postId ?? ""),
    queryFn: () => communityApi.getPost(postId as string),
    enabled: Boolean(postId),
  });
}
